import {
  Container,
  Stack,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Text } from "../components/Text";
import { Parentheses } from "../components/Parentheses";

export const Fungi = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack>
      <Stack
        justifyContent="center"
        sx={{
          backgroundImage: isMobile
            ? "url(/images/fungi-kv_sp.png)"
            : "url(/images/fungi-kv.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: isMobile ? 200 : 320,
        }}
      >
        <Container>
          <Text variant="h1" fontSize={40} color="#fff">
            真菌について
          </Text>
          <Text
            variant="h2"
            marginTop={1}
            color="#fff"
            sx={{
              fontSize: isMobile ? "22px !important" : 28,
            }}
          >
            About Fungi
          </Text>
        </Container>
      </Stack>
      <Stack id="1">
        <Container>
          <Stack direction="row" justifyContent="space-between" flexWrap="wrap">
            <Stack width={isMobile ? "100%" : "56%"}>
              <Parentheses>
                <Stack>
                  <Text variant="h3" color="primary" lineHeight={1.5}>
                    真菌とは
                  </Text>
                  <Text marginTop={2} lineHeight={2}>
                    真菌は、カビ・酵母・キノコなどを含む微生物の一種で、
                    {isMobile ? null : <br />}
                    植物や動物とは異なる独自の進化を遂げた生物です。
                    <br />
                    真菌は土壌、空気、水中など地球上のあらゆる環境に生息し、
                    {isMobile ? null : <br />}
                    発酵食品の生産や抗生物質の生成など、私たちの生活に密接に関わっています。
                  </Text>
                </Stack>
              </Parentheses>
            </Stack>
            <Stack
              width={isMobile ? "60%" : "37%"}
              textAlign={"center"}
              margin={isMobile ? "20px auto" : 0}
            >
              <img src="/images/fungi.png" alt="" />
            </Stack>
          </Stack>
        </Container>
      </Stack>
      <Stack
        id="2"
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                ゲノム編集とは
              </Text>
              <Text marginTop={2} lineHeight={2}>
                ゲノム編集（Genome
                Editing）とは、生物のDNAをピンポイントで改変する技術です。従来の遺伝子組換え技術とは異なり、狙った遺伝子だけを操作できるため、高精度な品種改良が可能です。特に真菌のゲノム編集は、食品、医療、バイオ燃料など幅広い分野での応用が期待されています。
                <br />
                しかし、従来の技術ではコストや技術的課題が多く、実用化が進みにくい状況でした。ゲノム編集は、従来の育種技術と比べて圧倒的に短期間で品種改良を実現できる革新的な技術です。従来の方法では数年から数十年を要する育種プロセスも、ゲノム編集を活用することで、数か月から数年で同様の結果を得ることが可能になります。
                <br />
                これにより、新しい機能を持つ微生物の開発や、環境負荷を低減する持続可能な技術の確立が加速されます。MycoGenomeでは、独自の非遺伝子組換え型ゲノム編集技術「MycoEdita」を開発し、より安全かつ効率的な微生物の改良を実現しています。この技術を活用することで、食品の発酵プロセスの最適化や、バイオ燃料の生産効率向上など、産業界に幅広く貢献していきます。
                <br />
                <br />
                代表的な技術に**CRISPR-Cas9（クリスパー・キャスナイン）**があります
                <br />。
                事例①：ゲノム編集食品ゲノム編集技術を使って開発された食品の一例が、高GABAトマトです。GABA（γ-アミノ酪酸）は血圧を下げる効果があるとされており、ゲノム編集によってこの成分を増やしたトマトが日本でも販売されています。
              </Text>
            </Stack>
          </Parentheses>
          {/* <Stack maxWidth={560} margin={isMobile ? "30px auto 0" : "70px auto"}>
            <img src="/images/genome.png" alt="" />
          </Stack> */}
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                遺伝子組み換えとは
              </Text>
              <Text marginTop={2} lineHeight={2}>
                遺伝子組換え（Genetic Modification,
                GM）とは、生物の遺伝子を他の生物の遺伝子と入れ替えたり、新しい遺伝子を加えたりする技術です。通常、異なる種の遺伝子を組み込むことが多いため、「外来遺伝子」を持つ生物が作られます。
                <br />
                <br />
                事例①：遺伝子組換え作物（GM作物）スーパーで見かける「遺伝子組換え食品」として代表的なのが遺伝子組換え大豆やトウモロコシです。例えば、害虫に強いトウモロコシは、**バクテリア由来の害虫抵抗性遺伝子（Bt遺伝子）**を組み込むことで、農薬を減らしつつ害虫の被害を防ぐことができます。
              </Text>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
      <Stack id="3">
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                産業的活用
              </Text>
              <Text marginTop={2} lineHeight={2}>
                産業的活用の現状真菌（微生物）は、古くからさまざまな産業分野で活用されてきました。食品分野では、酵母や麹菌を用いた発酵技術が味噌・醤油・酒類の製造に利用され、医薬品分野では抗生物質の生産に不可欠な微生物としての役割を果たしています。また、近年では、バイオ燃料やプラスチック代替素材の生産、土壌改良材としての活用など、環境負荷の低減にも貢献しています。しかし、これらの微生物の活用には長期間の品種改良が必要であり、期待する機能を持つ菌株を得るまでに膨大な時間とコストがかかることが課題となっています。
                <br />
                ゲノム編集による持続可能な社会への貢献ゲノム編集技術の進化により、これまで困難だった微生物の改良が短期間で実現可能になりました。当社技術「MycoEdita」は、従来の育種に比べ、より精密かつ効率的に真菌の機能を強化できる非遺伝子組換え型の技術です。この技術を活用することで、以下のような分野に貢献しています。
              </Text>
              <List sx={{ marginTop: 1.6 }}>
                {[
                  "食品・発酵産業：発酵効率を向上させた酵母や、風味を向上させる菌株の開発",
                  "農業・畜産：病害抵抗性を付与する菌の開発や、飼料の消化吸収を高める微生物の提供",
                  "バイオ燃料・環境分野：リグニン分解能力を強化した微生物によるバイオエタノール生産の向上",
                  "化学・製薬分野：医薬品や有用物質を高効率で生産する微生物の改良",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
          <Stack
            display="grid"
            gridTemplateColumns={isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)"}
            gap="15px"
            margin={isMobile ? "30px auto 0" : "70px auto"}
            sx={{
              img: {
                width: "100%",
              },
            }}
          >
            <Stack>
              <img src="/images/industry-1.png" alt="" />
            </Stack>
            <Stack>
              <img src="/images/industry-2.png" alt="" />
            </Stack>
            <Stack>
              <img src="/images/industry-3.png" alt="" />
            </Stack>
            <Stack>
              <img src="/images/industry-4.png" alt="" />
            </Stack>
          </Stack>
        </Container>
      </Stack>
      <Stack
        id="4"
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                当社ターゲット
              </Text>
              <Text marginTop={2} lineHeight={2}>
                MycoGenomeは、微生物（真菌）のゲノム編集技術を活用し、以下の分野で革新をもたらします。
              </Text>
              <List sx={{ marginTop: 1.6 }}>
                {[
                  "食品・発酵産業：より高品質な発酵微生物の開発",
                  "農業・畜産：病害抵抗性を付与する微生物や飼料添加微生物の開発",
                  "環境・バイオ燃料：持続可能な航空燃料（SAF）向けの微生物改良",
                  "化学・医薬品：有用物質を生産する微生物の改良",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
              <Text marginTop={2} lineHeight={2}>
                これらの分野で、特許ライセンス、共同研究、ゲノム編集ツールの販売を通じ、産業界に貢献します。
              </Text>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
    </Stack>
  );
};
